import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import Vue from 'vue';
import Load from '@/components/loading/directive';
import variables from '@/assets/styles/variables.scss';
var isFalsy = function isFalsy(value) {
  return value === 0 ? false : !value;
};
var trigger = function trigger(el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
};
var options = {
  hide: true,
  text: 'loading',
  themeColor: variables.theme
};
var directives = [{
  name: 'load',
  logic: {
    bind: function bind(el, binding) {
      var language = Vue.prototype.$t && Vue.prototype.$t('989') || false;
      var text = el.getAttribute('loading-text') || language || options.text;
      var node = new Load({
        data: function data() {
          return _objectSpread(_objectSpread({}, options), {}, {
            text: text
          });
        }
      });
      node.$mount();
      el.appendChild(node.$el);
      el.load = node;
      el.style.position = 'relative';
      node.hide = binding.value;
    },
    update: function update(el, binding) {
      el.load.hide = binding.value;
    }
  }
}, {
  name: 'number',
  logic: {
    bind: function bind(el, binding, vnode) {
      var dom = el.tagName === 'INPUT' ? el : el.querySelector('input');
      if (dom) {
        var formateData = binding.value;
        el.dom = dom;
        el.handler = function (e) {
          if (e.target.value === '') return false;
          var point = formateData.point || 0;
          var value = parseFloat(e.target.value);
          console.log(value, e.target.value);
          var result = value || 0;
          // 输入值不合法则取最小值
          if (value === 0 || !value) {
            var defaultValue = formateData.min || 0;
            e.target.value = !isFalsy(formateData.default) ? formateData.default.toFixed(point) : defaultValue.toFixed(point);
            return trigger(dom, 'input');
          }
          // 小于最小值则等于最小值
          // 这里通过isFalsy判断是考虑到0也是合法值而不是虚值
          if (!isFalsy(formateData.min) && value < formateData.min) result = formateData.min;
          // 大于最大值则等于最大值
          if (formateData.max && value > formateData.max) result = formateData.max;
          e.target.value = result.toFixed(point);
          trigger(dom, 'input');
        };
        dom.addEventListener('change', el.handler);
        // dom.addEventListener('blur', el.handler)
      }
    },
    unbind: function unbind(el) {
      if (el.dom) {
        el.dom.removeEventListener('input', el.handler);
        el.dom.removeEventListener('blur', el.handler);
      }
    }
  }
}];
directives.forEach(function (item) {
  Vue.directive(item.name, item.logic);
});